<template>
  <div
    class="card-groups-picker crdgrpicker text-noselect"
    draggable="false"
    :style="`--weight-range:${l_weight}`"
    @mousedown="handleMousedown()"
    @touchstart="handleMousedown()"
  >
    <div class="crdgrpicker_left">
      <div
        class="crdgrpicker_ra_table-wrapper"
        @mouseleave="
          () => {
            tooltipItem.visible = false
            tooltipItem.shortcutsVisible = false
          }
        "
      >
        <div
          v-if="l_groups[tooltipItem.idx]"
          ref="tooltip1"
          :style="tooltipItem.shortcutsVisible ? 'opacity: 1' : 'opacity: 0'"
          :class="tooltipItem.shortcutsVisible ? 'csst_content_hoverable' : 'no-events'"
          style="position: fixed; z-index: 10; min-width: 3rem; padding: 0.125rem"
          class="csst_content csst_content_visible f-center f-column"
        >
          <GwBtns
            :options="presets"
            style="
              --gwbtn-padding: 0 0.25rem;
              --gwbtn-height: 1.5rem;
              --gwbtn-size: 0.875rem;
              top: -2rem;
            "
            @click="
              (_e, num) => {
                setGroupRange(l_groups[tooltipItem.idx], num)
              }
            "
          >
            <template #default="{ item }">
              {{ item * 100 }}
            </template>
          </GwBtns>
        </div>
        <div
          v-if="l_groups[tooltipItem.idx]"
          ref="tooltip2"
          :style="tooltipItem.visible ? 'opacity:1' : 'opacity:0'"
          style="position: fixed; z-index: 10; min-width: 3rem; padding: 0.25rem; font-size: 0.7rem"
          class="csst_content csst_content_visible f-center f-column line-height_1"
        >
          <div class="weight_700">
            {{ numFixed((l_groups[tooltipItem.idx].range || 0) * 100, 1) }}%
          </div>
        </div>
        <div
          class="crdgrpicker_ra_table text-noselect"
          :style="tableStyle"
        >
          <!-- v-for="(group, index) in [l_groups[0]]" -->
          <div
            v-for="(group, index) in l_groups"
            :key="group.id"
            :ref="`group_${group.id}`"
            class="crdgrpicker_ra_table_rtc"
            :class="{
              crdgrpicker_ra_table_rtc_active: group.range,
            }"
            :data-cell-id="group.id"
            :style="`--opacity-range: ${group.range};`"
            @touchstart="
              e => {
                setToggleValue(group, index)
                toggle(e, group, index, 'touchstart')
                tooltipItem.visible = false
              }
            "
            @mousedown="
              e => {
                setToggleValue(group, index)
                toggle(e, group, index, 'mousedown')
                tooltipItem.visible = false
              }
            "
            @mouseup="tooltipItem.visible = true"
            @mouseenter="
              e => {
                swipeToogleGroup(e, group, index, 'mouseenter')
                setTooltip(group)
              }
            "
            @touchmove="e => swipeToogleGroup(e, group, index, 'touchmove')"
            @mousewheel="e => handleMouseWheel(e, group)"
          >
            {{ group.id }}
          </div>
        </div>
        <slot name="under_table"></slot>
      </div>

      <div class="crdgrpicker_undertable">
        <div class="crdgrpicker_slider">
          <RangeInput
            :values="[
              {
                id: 0,
                cssStyle: `
                --clr-input-back: var(--clr-black-3);
                --clr-input-handle: var(--clr-error);
                `,
                percentage: rangeInputs[0],
                title: $t('common.from'),
              },
              {
                id: 1,
                cssStyle: `
                --clr-input-back: var(--clr-primary);
                --clr-input-handle: var(--clr-primary);
                `,
                percentage: rangeInputs[1],
                title: $t('common.to'),
              },
              {
                id: 3,
                cssStyle: `--clr-input-back: var(--clr-black-3);`,
                percentage: rangeInputs[2],
              },
            ]"
            @values:update="({ values }) => handleInput(values)"
            @update:wheelend="handleMouseup()"
            @values:updateend="handleMouseup()"
          >
          </RangeInput>
        </div>

        <div
          class="crdgrpicker_fromto"
          style="z-index: 9"
        >
          <div
            v-for="(nItem, idx) in [
              {
                id: 'from',
                title: $t('common.from'),
                cssStyle: '--clr-focus: var(--clr-error)',
                min: 0,
              },
              {
                id: 'to',
                title: $t('common.to'),
                cssStyle: '--clr-focus: var(--clr-primary)',
                min: 1,
              },
            ]"
            :key="nItem.id"
            class="crdgrpicker_fromto_item"
          >
            <div class="weight_500">
              {{ nItem.title }}
            </div>

            <div
              class="input-cont csst"
              @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'top' })"
            >
              <NumberInput
                class="z-index_2"
                :value="
                  numFixed(
                    (idx === 0 ? rangeInputs[0] : rangeInputs[0] + rangeInputs[1]) * 100,
                    idx,
                  )
                "
                :tstPrefix="`crdgrpicker_${nItem.id}_`"
                :min="nItem.min"
                :max="100"
                :step="1"
                :style="nItem.cssStyle"
                :data-tst="`crdgrpicker_fromto_${nItem.title}`"
                @input="
                  num => handleNumInput(idx === 0 ? num / 100 : num / 100 - rangeInputs[0], idx)
                "
              />
              <GwBtns
                :options="presets"
                style="position: fixed; --gwbtn-padding: 0 0.25rem; padding: 0.25rem"
                class="csst_content csst_content_hoverable gwbtns_horizontal_grey"
                @click="
                  (_e, num) => {
                    handleNumInput(idx === 0 ? num : num - rangeInputs[0], idx)
                    handleWheelEnd()
                  }
                "
              >
                <template #default="{ item }">
                  {{ item * 100 }}
                </template>
              </GwBtns>
            </div>
          </div>
          <div class="crdgrpicker_weight crdgrpicker_fromto_item">
            <div class="weight_500">
              {{ $t('common.weight') }}
            </div>
            <div
              class="input-cont csst"
              @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'top' })"
            >
              <NumberInput
                class="z-index_2"
                :value="numFixed(l_weight * 100, 2)"
                :min="0"
                :step="0.5"
                :decimals="2"
                :max="100"
                style="--clr-focus: var(--clr-range)"
                @input="num => handleRangeInput(num / 100)"
              />
              <GwBtns
                :options="presets"
                style="position: fixed; --gwbtn-padding: 0 0.25rem; padding: 0.25rem"
                class="csst_content csst_content_hoverable gwbtns_horizontal_grey"
                @click="(_e, item) => handleRangeInput(item)"
              >
                <template #default="{ item }">
                  {{ numFixed(item * 100, 2) }}
                </template>
              </GwBtns>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import { throttle } from 'lodash'
import { balanceValues } from '@/helpers/helpers'
import { rangesDataSkeleton } from '@/helpers/solution'
import NumberInput from '@/components/lib/NumberInput'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import RangeInput from '@/components/lib/RangeInput'
import GwBtns from '@/components/lib/GwBtns'
import cgp_dict from './cgp_dict.json'

export default {
  name: 'CardGroupesPickerV2',
  components: {
    NumberInput,
    RangeInput,
    GwBtns,
  },
  mixins: [format_mix, float_mix],
  props: {
    groups: {
      default: () =>
        rangesDataSkeleton().tableGroups.map(i => ({
          id: i,
          range: 1,
          hand_count: i.hand_count,
          hands: i.combos.map(cc => cc.id),
        })),
    },
    tableStyle: String,
    instaApply: Boolean,
  },
  emits: ['update'],
  data() {
    return {
      mousedown: false,
      l_groups: [],
      l_weight: 1,
      l_manualRange: 1,
      rangeInputs: [0, 1, 0],
      presets: [0, 0.25, 0.5, 0.75, 1],

      // importError: '',
      // importedGroups: '',
      // rangeCopied: false,
      wheelEndTimeout: null,
      tooltipItem: {
        visible: false,
        shortcutsVisible: false,
        idx: 0,
        // group: { id: '' },
      },
    }
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  methods: {
    setTooltip(group) {
      this.tooltipItem.shortcutsVisible = false

      const el = this.$refs[`group_${group.id}`]
      if (this.mobile || !el) {
        this.tooltipItem.visible = false
        return
      }

      const idx = this.l_groups.findIndex(i => i.id === group.id)
      this.tooltipItem = {
        visible: !this.mousedown,
        idx,
      }
      nextTick(() => {
        requestAnimationFrame(() => {
          const referenceEl = el[0]
          const element1 = this.$refs.tooltip1
          const element2 = this.$refs.tooltip2
          // const boundary = this.$refs.cont
          // if (referenceEl && element1 && element2 && boundary) {
          if (referenceEl && element1 && element2) {
            this.fl_setPositionStyle({
              referenceEl,
              // boundary,
              element: element1,
              options: {
                strategy: 'fixed',
                placement: 'top',
                offset: -1,
              },
            })
            this.fl_setPositionStyle({
              referenceEl,
              // boundary,
              element: element2,
              options: {
                strategy: 'fixed',
                placement: 'bottom',
                offset: 0,
              },
            })
          }
        })
      })
    },
    handleWheelEnd() {
      // if(this.mousedown) return
      // this.mousedown = true
      this.handleMouseup()
      // this.handleMousedown()
    },
    handleMousedown() {
      this.mousedown = true
      this.addEventListeners()
    },
    handleMouseup() {
      this.mousedown = false
      this.removeEventListeners()
      if (this.instaApply) {
        this.apply()
      }
    },
    addEventListeners() {
      window.addEventListener('mouseup', this.handleMouseup)
      window.addEventListener('touchend', this.handleMouseup)
    },
    removeEventListeners() {
      window.removeEventListener('mouseup', this.handleMouseup)
      window.removeEventListener('touchend', this.handleMouseup)
    },
    setGroups() {
      this.l_groups = JSON.parse(JSON.stringify(this.groups))
    },
    setToggleValue(group) {
      this.l_manualRange = group.range === this.l_weight ? 0 : this.l_weight
    },
    toggle(e, group) {
      e.preventDefault()
      this.setGroupRange(group)
    },
    swipeToogleGroup(e, group) {
      if (this.mousedown) {
        if (e.touches?.[0]) {
          const cell = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY)
          const groupId = cell?.attributes?.['data-cell-id']?.value
          if (!groupId) return
          group = { id: groupId }
        }
        this.setGroupRange(group)
      }
    },
    handleMouseWheel: throttle(function (e, group) {
      this.tooltipItem.shortcutsVisible = true
      const step = 0.01
      let val = group.range

      if (e.deltaY < 0) {
        val += step
      } else {
        val -= step
      }

      val = Math.max(Math.min(val, 1), 0)

      const idx = this.l_groups.findIndex(i => i.id === group.id)
      this.l_groups[idx].range = val
      this.updateGroups(this.l_groups)
      this.mouseWheelEnd()
    }, 1),

    mouseWheelEnd(throttleTime = 5) {
      clearTimeout(this.wheelEndTimeout)
      this.wheelEndTimeout = setTimeout(() => {
        this.handleWheelEnd()
      }, throttleTime + 20)
    },
    setGroupRange(group, manualRange = this.l_manualRange) {
      // console.log(group)
      const idx = this.l_groups.findIndex(i => i.id === group.id)
      this.l_groups[idx].range = manualRange
      this.updateGroups(this.l_groups)
    },

    updateGroups(groups) {
      this.l_groups = groups
    },
    apply() {
      this.$emit('update', {
        groups: this.l_groups,
        combos: this.combos,
        percentage: this.percentage,
      })
    },

    //----
    handleNumInput(num, index) {
      num = this.numFixed(num, 10)
      if (num < 0) {
        this.handleNumInput(this.rangeInputs[0] + num, 0)
        num = 0
      }
      let res = [...this.rangeInputs]
      res = res.map((i, idx) => {
        if (idx === index) {
          return num
        }
        return i
      })

      res = balanceValues(res, index)
      this.rangeInputs = res
      this.setGroupsByInput(1)
    },
    handleInput(values) {
      this.rangeInputs = values.map(i => i.percentage)
      this.setGroupsByInput(1)
    },
    // @tombos
    // When you select a weight, then use the slider, every hand is updated with selected weight.
    // I get why you did this, but there's no use case.
    // If every hand is equally weighted then it's strategically the same as if every hand was 100% weighted.
    //  >> hardcoding it to 1
    setGroupsByInput(weight = 1) {
      const frequencies = [
        this.numFixed(this.rangeInputs[0], 2),
        this.numFixed(this.rangeInputs[1], 2),
      ]
      const freFrom = frequencies[0]
      const freTo = frequencies[1] + freFrom
      let res = cgp_dict.map(i => {
        const group = this.l_groups.find(g => g.id === i[0])
        return {
          ...group,
          range: i[1] >= freFrom && i[1] <= freTo ? weight : 0,
        }
      })

      res = res.sort(
        (a, b) =>
          this.l_groups.findIndex(i => i.id === a.id) - this.l_groups.findIndex(i => i.id === b.id),
      )

      this.updateGroups(res)
    },

    handleRangeInput(num) {
      this.l_weight = num
    },
  },
  computed: {
    combos() {
      return this.l_groups.reduce((acc, group) => acc + group.hand_count * group.range, 0)
    },
    percentage() {
      return this.combos / 1326
    },
  },
  watch: {
    groups: {
      immediate: true,
      handler: 'setGroups',
    },
  },
}
</script>

<style lang="scss" scoped>
.crdgrpicker {
  --clr-rtc: var(--clr-range-default);
  display: flex;
  position: relative;
  gap: 1rem;
  flex: 1;
  &_left {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.5rem;
  }
  &_right {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &_undertable {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  &_fromto {
    display: flex;
    gap: 0.25rem;
    &_item {
      display: flex;
      align-items: center;
      flex-direction: column;
      background: var(--clr-black-2);
      padding: 0.25rem 0.25rem 0.25rem 0.25rem;
      gap: 0.25rem;
      border-radius: 4px;
      width: 100%;
    }
  }
  &_infoitem {
    color: var(--clr-grey-2);
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    border: solid 1px var(--clr-black-2);
  }
  &_importexport {
    display: flex;
    gap: 2px;
    flex-direction: column;
  }
  &_ra_table {
    &-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    --border-width: 1px;
    --clr-back: var(--clr-black-0-3);

    flex: 1;
    max-width: 100vw;
    display: grid;
    grid-template-columns: repeat(13, 1fr);
    grid-template-rows: repeat(13, 1fr);
    touch-action: none;
    gap: 1px;
    &_rtc {
      background: var(--clr-back);
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      min-height: 2rem;
      cursor: pointer;
      position: relative;
      text-shadow: var(--text-shadow_drop);
      font-size: 0.8rem;
      font-weight: 500;
      z-index: 1;
      color: var(--clr-grey-2);

      &_active {
        color: var(--clr-white-0);
      }

      --rtc-radius: 4px;
      &:nth-child(1) {
        border-top-left-radius: var(--rtc-radius);
        overflow: hidden;
      }
      &:nth-child(13) {
        border-top-right-radius: var(--rtc-radius);
        overflow: hidden;
      }
      &:nth-child(157) {
        border-bottom-left-radius: var(--rtc-radius);
        overflow: hidden;
      }
      &:nth-child(169) {
        border-bottom-right-radius: var(--rtc-radius);
        overflow: hidden;
      }
      // box-shadow: none;
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--clr-rtc);
        height: calc(var(--opacity-range) * 100%);
        z-index: -1;
      }
    }
  }
}

// @media not all and (min-resolution: 0.001dpcm) {
@media (hover: hover) and (pointer: fine) {
  .crdgrpicker_ra_table {
    &_rtc {
      &:hover {
        --opacity-range: var(--weight-range);
        color: var(--clr-white-0);
        box-shadow: 0px 0px 0px 2px var(--clr-primary);
        z-index: 4;
        border-radius: 4px;
        overflow: hidden;
      }
    }
  }
}
// }
</style>
